/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Apply_B_To_A_TitleInputs */



/**
* | output |
* | --- |
* | "Apply changes from Group B to Group A" |
*
* @param {Compare_Event_Groups_Apply_B_To_A_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_apply_b_to_a_title = /** @type {((inputs?: Compare_Event_Groups_Apply_B_To_A_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Apply_B_To_A_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer les modifications du groupe B au groupe A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungen von Gruppe B auf Gruppe A übertragen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applica le modifiche dal Gruppo B al Gruppo A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перенесите изменения из группы B в группу A.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar cambios del Grupo B al Grupo A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将B组的变更应用于A组。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループBからグループAに変更を適用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह B से समूह A में परिवर्तन लागू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar as alterações do Grupo B ao Grupo A.")
	return /** @type {LocalizedString} */ ("Apply changes from Group B to Group A")
});